import { Avatar, Status, UserStatus } from "@chatscope/chat-ui-kit-react";
import { Image } from "react-img-placeholder";
import { HTMLAttributes } from "react";

export const AvatarWithPlaceholder = ({
	displayName,
	photoUri,
	placeholderUri,
	status,
	"aria-label": ariaLabel,
	...rest
}: HTMLAttributes<HTMLDivElement> & {
	displayName?: string;
	photoUri?: string | null;
	placeholderUri?: string | null;
	status?: UserStatus;
	onClick?: () => void;
	size?: "xs" | "sm" | "md" | "lg" | "fluid";
}) => {
	return (
		<Avatar {...rest} aria-label={ariaLabel}>
			<Image
				title={photoUri}
				alt={displayName}
				src={photoUri}
				placeholderSrc={placeholderUri ?? undefined}
				aria-hidden={ariaLabel ? "true" : undefined}
			/>
			{typeof status === "string" && <Status status={status} size="md" />}
		</Avatar>
	);
};
